// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_AtributosCategoriaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/item_attributes/atributos_categoria/{category_id}
 *
 * Returns the attribute bindings (with nested options for `select` types)
 * configured for the given service category. Legacy `dados` shape is a
 * list, so getDados() returns the array directly.
 */
import type { Item_attributes_CategoryBindingRow } from './Item_attributes_CategoryBindingRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Item_attributes_AtributosCategoriaResponseDados = Item_attributes_CategoryBindingRow[];

export type Item_attributes_AtributosCategoriaResponse = ApiResponse<Item_attributes_AtributosCategoriaResponseDados>;

registerResponseContract('Item_attributes_AtributosCategoriaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_category_attribute_id:             { type: 'number',  required: true },
      so_category_attribute_category_id:    { type: 'number',  required: true },
      so_category_attribute_attribute_id:   { type: 'number',  required: true },
      so_category_attribute_required:       { type: 'number',  required: true },
      so_category_attribute_display_order:  { type: 'number',  required: true },
      so_category_attribute_created_at:     { type: 'string',  required: true },
      so_item_attribute_name:               { type: 'string',  required: true },
      so_item_attribute_type:               { type: 'string',  required: true },
      so_category_attribute_is_description: { type: 'number',  required: false },
      options: {
        type: 'array',
        required: false,
        items: {
          so_item_attribute_option_id:            { type: 'number',  required: true },
          so_item_attribute_option_attribute_id:  { type: 'number',  required: true },
          so_item_attribute_option_value:         { type: 'string',  required: true },
          so_item_attribute_option_icon_svg:      { type: 'string',  required: false },
          so_item_attribute_option_display_order: { type: 'number',  required: true },
          so_item_attribute_option_active:        { type: 'number',  required: true },
          so_item_attribute_option_created_at:    { type: 'string',  required: true },
        },
      },
    },
  },
})
